import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentInvalidVatReleaseReasonCustomNameError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.vat-release-reason.required');
    }
}
